import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import { UserNotify } from "src/app/support/notify-decorator";
import { environment } from "src/environments/environment";
import { Account, Domain, Tenant } from "../models/organization/organization";
import { PaginatedResult } from "src/app/support/paginated-result";

@Injectable()
export class OrganizationBackend {
  constructor(private http: HttpClient) {}

  tenants(): Observable<PaginatedResult<Tenant>> {
    return this.http.get<PaginatedResult<Tenant>>(
      `${environment.snoots.api.organization}/tenants`
    );
  }

  tenantLoad(id: string): Observable<Tenant> {
    const tenant = this.http.get<Tenant>(
      `${environment.snoots.api.organization}/tenants/${id}`
    );

    return tenant;
  }

  accountLoad(id: string): Observable<Account> {
    const account = this.http.get<Account>(
      `${environment.snoots.api.organization}/accounts/${id}`
    );

    return account;
  }

  domain(id: string): Observable<Domain> {
    const domain = this.http.get<Domain>(
      `${environment.snoots.api.organization}/domains/${id}`
    );

    return domain;
  }

  onBoarding(dto: any): Observable<any> {
    const res = this.http.post<Domain>(
      `${environment.snoots.api.organization}/users/me/accounts`,
      dto
    );

    return res;
  }

  @UserNotify({
    successMessage: marker("Account aggiornato"),
    errorMessage: marker("Impossibile aggiornare account")
  })
  updateAccount(data: Partial<Account>, id: string): Observable<Account> {
    const account = this.http.patch<Account>(
      `${environment.snoots.api.organization}/accounts/${id}`,
      data
    );

    return account;
  }
}
